"use client";

import { Spin } from "antd";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, type ReactNode } from "react";
import { useAuth } from "@/auth/AuthContext";
import { AppShell } from "./AppShell";
import styles from "./auth-gate.module.css";

export function AuthGate({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const onLoginPage = pathname === "/login";

  useEffect(() => {
    if (status === "anonymous" && !onLoginPage) router.replace("/login");
    if (status === "authenticated" && onLoginPage) router.replace("/");
  }, [onLoginPage, router, status]);

  const showApp = status === "authenticated" && !onLoginPage;
  const waiting =
    status === "loading" ||
    (status === "anonymous" && !onLoginPage) ||
    (status === "authenticated" && onLoginPage);
  // The route segment has to stay mounted. Replacing it with a spinner drops it
  // from the tree, and Next.js then cannot validate instant navigation.
  const page = showApp ? <AppShell>{children}</AppShell> : children;

  if (!waiting) return page;

  return (
    <>
      <div className={styles.waiting}>
        <Spin />
      </div>
      <div hidden>{page}</div>
    </>
  );
}
